import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectMainClient } from '~/reducers/mainClientSlice';

import {
    ManageStopControlListItem,
    ManageStopControlMenu,
    ManageStopControlMultiple,
    StopModalMenuButton,
    theme
} from '~/ui';

import constants from '~/utils/constants';

function MultiTasksControl({
    selectedTasks,
    onClickDispatchButton = () => {},
    onClickPairButton = () => {},
    footerButtonTitle,
    footerButtonIcon,
    onClickFooterButton = () => {}
}) {
    const [selectedStops, setSelectedStops] = useState([]);
    const mainClient = useSelector(selectMainClient);
    const { t } = useTranslation('translation');

    useEffect(() => {
        setSelectedStops(selectedTasks);
    }, [selectedTasks]);

    function _handleClickDispatch() {
        return onClickDispatchButton && onClickDispatchButton();
    }

    function _handleClickPair() {
        return onClickPairButton && onClickPairButton();
    }

    function _getStopList() {
        return selectedStops.map((selectedStop) => (
            <ManageStopControlListItem
                key={selectedStop.twoPartId}
                className="multi-tasks-control_list-item"
                text={selectedStop.name}
                iconButtonText="?"
                iconButtonTextColor={theme.colors.comet}
                data-testid="multi-tasks-control-list-item"
            />
        ));
    }
    return (
        <ManageStopControlMultiple
            className="multi-tasks-control"
            controlTitle={t(
                'UnassignedTasksControl.title.no_of_tasks_selected',
                {
                    count: selectedStops.length
                }
            )}
            controlHelp={t('UnassignedTasksControl.title.selection_info')}
            stopList={_getStopList()}
            footerButtonTitle={footerButtonTitle}
            footerButtonIcon={footerButtonIcon}
            onClickFooterButton={onClickFooterButton}
            data-testid="multi-tasks-control"
        >
            <ManageStopControlMenu>
                <StopModalMenuButton
                    buttonIcon="vehicleEmpty"
                    buttonText={t('UnassignedTasksControl.button.dispatch')}
                    onClick={_handleClickDispatch}
                    disabled={
                        selectedStops.length >
                        constants.onDemandDispatch.CONTROL_DISPATCH_LIMIT
                    }
                    buttonStopText={t(
                        'UnassignedTasksControl.button.tasksSelected',
                        {
                            count: selectedStops.length,
                            total: constants.onDemandDispatch
                                .CONTROL_DISPATCH_LIMIT
                        }
                    )}
                    showButtonArrow
                    data-testid="multi-tasks-control-dispatch"
                />
                {mainClient?.preferences?.enableTwoPartTaskEditing && (
                    <StopModalMenuButton
                        buttonIcon="link"
                        buttonText={t('UnassignedTasksControl.button.pair')}
                        onClick={_handleClickPair}
                        showButtonArrow
                        data-testid="multi-tasks-control-pair"
                    />
                )}
            </ManageStopControlMenu>
        </ManageStopControlMultiple>
    );
}

export default MultiTasksControl;
